import React from 'react';

import { BulkUpdateSteps } from '@rcp/types';
import Stepper, { Step } from '../../../../../widgets/stepper';
import { localizationService } from 'src/services';
import { ChooseFieldsStep, InputFieldValuesStep, BulkUpdateSummaryStep } from './steps';

import './bulk-update.scss';

const AuthoritiesBulkUpdateComponent: React.FunctionComponent = () => {
	let title = localizationService.getLocalizedString('bulkUpdate.bulkUpdate');
	let step1Title = localizationService.getLocalizedString('bulkUpdate.chooseFieldsToUpdate');
	let step2Title = localizationService.getLocalizedString('bulkUpdate.update');
	let step3Title = localizationService.getLocalizedString('bulkUpdate.results');
	return (
		<div className="page">
			<div className="page-header">
				<h1>{title}</h1>
			</div>
			<div className="page-wrapper">
				<div className="main">
					<section>
						<Stepper vertical={true} initialStep={BulkUpdateSteps.STEP1_CHOOSE_FIELDS}>
							<Step stepId={BulkUpdateSteps.STEP1_CHOOSE_FIELDS} title={step1Title}>
								<ChooseFieldsStep />
							</Step>
							<Step stepId={BulkUpdateSteps.STEP2_INPUT_VALUES} title={step2Title}>
								<InputFieldValuesStep />
							</Step>
							<Step stepId={BulkUpdateSteps.STEP3_SUMMARY} title={step3Title}>
								<BulkUpdateSummaryStep />
							</Step>
						</Stepper>
					</section>
				</div>
			</div>
		</div>
	);
};

export const AuthoritiesBulkUpdate = AuthoritiesBulkUpdateComponent;
